<template>
  <div class="buyerShop">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px">
      <el-row :gutter="20">
        <el-col :xs="18" :sm="18" :md="18" :lg="18" :xl="18">
          <el-form-item :label="$t('crm.SevenDayNoReasonReturn')" prop="supportWithoutReason">
            <el-radio-group v-model="ruleForm.supportWithoutReason" @change="handleSupportWithoutReasonChange">
              <el-radio :label="1">{{ $t('crm.support') }}</el-radio>
              <el-radio :label="0">{{ $t('crm.notSupport') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item
            v-if="ruleForm.supportWithoutReason === 1"
            :label="$t('crm.ShowNoReasonAfterSaleImage')"
            prop="showNoReasonAfterSaleImage"
          >
            <el-radio-group v-model="ruleForm.showNoReasonAfterSaleImage">
              <el-radio :label="1">{{ $t('crm.show') }}</el-radio>
              <el-radio :label="0">{{ $t('crm.notShow') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('crm.vendorSaleAfterAddressInfo')">
            <el-table :data="saleAfterAddressData" :header-cell-style="{backgroundColor: '#f0f0f0'}" border>
              <el-table-column prop="companyName" :label="$t('crm.companyName')"></el-table-column>
              <el-table-column prop="receiveUserName" :label="$t('crm.receiveUserName')"></el-table-column>
              <el-table-column prop="receivePhone" :label="$t('crm.receivePhone')"></el-table-column>
              <el-table-column prop="receiveEmail" :label="$t('crm.receiveEmail')"></el-table-column>
              <el-table-column prop="receivePostCode" :label="$t('crm.receivePostCode')"></el-table-column>
              <el-table-column prop="receiveVatNum" :label="$t('crm.receiveVatNum')"></el-table-column>
              <el-table-column prop="receiveAddressCountry" :label="$t('crm.receiveAddressCountry')"></el-table-column>
              <el-table-column prop="receiveAddressCity" :label="$t('crm.receiveAddressCity')"></el-table-column>
              <el-table-column prop="receiveAddress" :label="$t('crm.receiveAddress')"></el-table-column>
              <el-table-column :label="$t('common.action')">
                <template slot-scope="scope">
                  <el-button type="text" @click="editAddressInfo(scope)" size="mini">
                    {{ $t('common.edit') }}
                  </el-button>
                  <el-button type="text" v-if="saleAfterAddressData.length > 1" @click="removeSaleAfterAddress(scope)" size="mini">
                    {{ $t('common.remove') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="text" @click="showAddressDialogInfo">{{ $t('crm.addAddressInfo') }}</el-button>
          </el-form-item>
        </el-col>

        <el-dialog :title="addressShowDialogForm.id ? $t('crm.editAddressInfo') : $t('crm.addAddressInfo')" :visible.sync="dialogVisibleAddressInfo" width="500px"
               :close-on-click-modal="false">
            <el-form :model="addressShowDialogForm" ref="addressShowDialogForm" label-width="120px">
              <el-form-item :label="$t('crm.companyName')" prop="companyName"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.companyName')}`  }]">
                <el-input v-model="addressShowDialogForm.companyName" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm.receiveUserName')" prop="receiveUserName"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receiveUserName')}`  }]">
                <el-input v-model="addressShowDialogForm.receiveUserName" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm.receivePhone')" prop="receivePhone"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receivePhone')}`  }]">
                <el-input v-model="addressShowDialogForm.receivePhone" maxlength="50"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm.receiveEmail')" prop="receiveEmail"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receiveEmail')}` }, { validator: validateEmail, trigger: 'blur' }]">
                <el-input v-model="addressShowDialogForm.receiveEmail" maxlength="200"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm.receivePostCode')" prop="receivePostCode"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receivePostCode')}`  }]">
                <el-input v-model="addressShowDialogForm.receivePostCode" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm.receiveVatNum')" prop="receiveVatNum"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receiveVatNum')}`  }]">
                <el-input v-model="addressShowDialogForm.receiveVatNum" maxlength="100"></el-input>
              </el-form-item>
              <el-form-item :label="$t('crm.receiveAddressCountry')" prop="receiveAddressCountryId"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receiveAddressCountry')}`  }]">
                <el-select v-model="addressShowDialogForm.receiveAddressCountryId"
                  @change="onchangeCountry">
                  <el-option v-for="item in addressCountrySelect"
                    :key="item.addressCountryId"
                    :label="item.name"
                    :value="item.addressCountryId"
                    >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('crm.receiveAddressCity')" prop="receiveAddressCity"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receiveAddressCity')}`  }]">
                <el-select v-model="addressShowDialogForm.receiveAddressCity"
                      filterable
                      remote
                      reserve-keyword
                      :remote-method="getBoutiqueCityListSelect">
                  <el-option v-for="item in addressCitySelect"
                    :key="item.cityName"
                    :label="item.cityName"
                    :value="item.cityName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('crm.receiveAddress')" prop="receiveAddress"
                            :rules="[{ required: true, message: `${$t('common.plzInput')}${$t('crm.receiveAddress')}`  }]">
                <el-input v-model="addressShowDialogForm.receiveAddress" maxlength="500"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogVisibleAddressInfo = false">{{ $t('common.cancel') }}</el-button>
              <el-button type="primary" @click="submitAddressInfo">{{ $t('common.ok') }}</el-button>
            </span>
          </el-dialog>


        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="10">
          <el-form-item label="">
            <el-button type="primary" size="small" @click="submit">{{ $t('common.save') }}</el-button>
            <el-button size="small" @click="close">{{ $t('common.back') }}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import {
  getAfterSaleDict,
  getAfterSalePerformance,
  updateAfterSalePerformance,
  getDictEnumList,
} from './api';

import {
  getBoutiqueCityList,
  getBoutiqueCountryList,
} from '../buyershop/api';

export default {
  data() {
    return {
      isEdit: false,
      isShow: false,
      orderPackType: [], // 打包装箱模式
      orderOperationType: [], // 订单操作模式集合
      logisticsType: [], // 物流运输模式
      rejectType: [], // 不接受售后类型集合
      productSourceType: [], // 商品数据对接方式
      addressCountrySelect: [],
      addressCitySelect: [],
      queryCityAddressCountryId: null,
      currentSelectAddressCountry: null,
      countryListMap: {},
      ruleForm: {
        vendorId: this.$route.params.id,
        vatNumber: null,
        afterSaleExpire: null,
        returnExpire: null,
        acceptSaleAfter: null,
        rejectSaleAfterType: null,
        rejectDefect: null,
        rejectSaleAfterCategory: null,
        portalVersionType: null,
        productSourceType: null,
        orderOperationType: null,
        orderPackType: null,
        logisticsType: null,
        stockException: null,
        priceException: null,
        performanceBottleneck: null,
        afterAddressVos: [{
          id: null,
          receiveUserName: null,
          receivePhone: null,
          receiveEmail: null,
          receivePostCode: null,
          receiveVatNum: null,
          receiveAddressCountryId: null,
          receiveAddressCountry: null,
          receiveAddressCity: null,
          receiveAddressCityId: null,
          receiveAddress: null,
          enabled: null,
        }],
        supportWithoutReason: null,
        showNoReasonAfterSaleImage: null
      },
      rules: {
        vendorName: [{ required: true, message: `${this.$t('common.plzInput')}${this.$t('crm.vendorName')}` }],
        vendorType: [{ required: true, message: `${this.$t('common.plzSelect')}${this.$t('crm.vendorType')}` }],
        supportWithoutReason: [{ required: true, message: `${this.$t('crm.SevenDayNoReasonReturn')}` }],
      },
      dialogVisibleAddressInfo: false,
      addressShowDialogForm: {
        companyName: null,
        receiveUserName: null,
        receivePhone: null,
        receiveEmail: null,
        receivePostCode: null,
        receiveVatNum: null,
        receiveAddressCountryId: null,
        receiveAddressCountry: null,
        receiveAddressCity: null,
        receiveAddressCityId: null,
        receiveAddress: null,
      },
    };
  },
  mounted() {
    // if (this.$route.path.indexOf('/crm/store/edit/') === 0) {
    //   this.isEdit = true;
    // }
    if (this.$route.params.id) {
      this.getDetail();
    }
    this.init();
  },
  methods: {
    init() {
      getAfterSaleDict().then(res => {
        if (res.data && res.data.data) {
          this.orderPackType = res.data.data.sale_after_order_pack_type || [];
          this.orderOperationType = res.data.data.sale_after_order_operation_type || [];
          this.logisticsType = res.data.data.sale_after_logistics_type || [];
          this.rejectType = res.data.data.reject_sale_after_type || [];
        }
      });
      getDictEnumList({
        parentCode: 'product_source_type',
      }).then(res => {
        if (res.success && res.data) {
          this.productSourceType = res.data || [];
        }
      });
      getBoutiqueCountryList().then(res => {
        const map = {};
        if(res.data && res.data.data){
          this.addressCountrySelect = res.data.data || [];
          this.addressCountrySelect.map(item => {
            map[item.addressCountryId] = item.name;
          });
        }
        this.countryListMap = map;
      });
    },
    getBoutiqueCityListSelect(query) {
      getBoutiqueCityList({
      countryId: this.addressShowDialogForm.receiveAddressCountryId,
      cityCode: query,
      }).then(res => {
        if(res.data && res.data.data){
          this.addressCitySelect = res.data.data || [];
        }
      });
    },
    getDetail() {
      getAfterSalePerformance({
        vendorId: this.$route.params.id,
      }).then(res => {
        if (res.data.success && res.data.data) {
          this.ruleForm = res.data.data || {};
        }
      })
    },
    submit() {
      this.$refs.ruleForm.validate((vali) => {
        if (!vali) { return; }
        updateAfterSalePerformance(this.ruleForm).then(res => {
          if (res.data.success) {
            this.$message.success('保存成功');
            this.getDetail();
            setTimeout(() => {
              this.$router.push({
                path: '/crm/list'
              })
            }, 1000);
          } else {
            this.$message.error(res.data.message || '系统异常');
          }
        })
      })
    },
    onchangeCountry(val) {
      this.queryCityAddressCountryId =  val;
      this.currentSelectAddressCountry = this.countryListMap[val];
      this.getBoutiqueCityListSelect('');
    },
    close() {
      window.close();
    },
    handleSupportWithoutReasonChange(val) {
      if (val === 0) {
        this.ruleForm.showNoReasonAfterSaleImage = null;
      } else if (val === 1 && this.ruleForm.showNoReasonAfterSaleImage === null) {
        this.ruleForm.showNoReasonAfterSaleImage = 1;
      }
    },
    removeSaleAfterAddress(scope){
      if (scope.row.id) {
        this.ruleForm.afterAddressVos[scope.$index].enabled = false;
      } else {
        this.payeeInfoData.splice(scope.$index, 1);
      }
    },
    editAddressInfo(scope){
      this._currEditIndex = scope.$index;
      this.addressShowDialogForm.id = scope.row.id;
      this.addressShowDialogForm.companyName = scope.row.companyName;
      this.addressShowDialogForm.receiveUserName = scope.row.receiveUserName;
      this.addressShowDialogForm.receivePhone = scope.row.receivePhone;
      this.addressShowDialogForm.receiveEmail = scope.row.receiveEmail;
      this.addressShowDialogForm.receivePostCode = scope.row.receivePostCode;
      this.addressShowDialogForm.receiveVatNum = scope.row.receiveVatNum;
      this.addressShowDialogForm.receiveAddressCountryId = scope.row.receiveAddressCountryId;
      this.addressShowDialogForm.receiveAddressCountry = scope.row.receiveAddressCountry;
      this.addressShowDialogForm.receiveAddressCity = scope.row.receiveAddressCity;
      this.addressShowDialogForm.receiveAddressCityId = scope.row.receiveAddressCityId;
      this.addressShowDialogForm.receiveAddress = scope.row.receiveAddress;
      this.onchangeCountry(scope.row.receiveAddressCountryId);
      this.dialogVisibleAddressInfo = true;
      this.$nextTick(() => {
        this.$refs.addressShowDialogForm.clearValidate();
      })
    },
    showAddressDialogInfo() {
      this.addressShowDialogForm.id = null;
      this.addressShowDialogForm.companyName = null;
      this.addressShowDialogForm.receiveUserName = null;
      this.addressShowDialogForm.receivePhone = null;
      this.addressShowDialogForm.receiveEmail = null;
      this.addressShowDialogForm.receivePostCode = null;
      this.addressShowDialogForm.receiveVatNum = this.ruleForm.vatNumber;
      this.addressShowDialogForm.receiveAddressCountryId = null;
      this.addressShowDialogForm.receiveAddressCountry = null;
      this.addressShowDialogForm.receiveAddressCity = null;
      this.addressShowDialogForm.receiveAddressCityId = null;
      this.addressShowDialogForm.receiveAddress = null;
      this.dialogVisibleAddressInfo = true;
      this.$nextTick(() => {
        this.$refs.addressShowDialogForm.clearValidate();
      })
    },
    submitAddressInfo() {
      const that = this;
      this.$refs.addressShowDialogForm.validate((vali) => {
        if (vali) {
          if (that._currEditIndex != null) {
            this.ruleForm.afterAddressVos[that._currEditIndex].companyName = that.addressShowDialogForm.companyName;
            this.ruleForm.afterAddressVos[that._currEditIndex].receiveUserName = that.addressShowDialogForm.receiveUserName;
            this.ruleForm.afterAddressVos[that._currEditIndex].receivePhone = that.addressShowDialogForm.receivePhone;
            this.ruleForm.afterAddressVos[that._currEditIndex].receiveEmail = that.addressShowDialogForm.receiveEmail;
            this.ruleForm.afterAddressVos[that._currEditIndex].receivePostCode = that.addressShowDialogForm.receivePostCode;
            this.ruleForm.afterAddressVos[that._currEditIndex].receiveVatNum = that.addressShowDialogForm.receiveVatNum;
            this.ruleForm.afterAddressVos[that._currEditIndex].receiveAddressCountry = this.currentSelectAddressCountry;
            this.ruleForm.afterAddressVos[that._currEditIndex].receiveAddressCountryId = that.addressShowDialogForm.receiveAddressCountryId;
            this.ruleForm.afterAddressVos[that._currEditIndex].receiveAddressCity = that.addressShowDialogForm.receiveAddressCity;
            this.ruleForm.afterAddressVos[that._currEditIndex].receiveAddress = that.addressShowDialogForm.receiveAddress;
          } else {
            that.ruleForm.afterAddressVos.push({
              ...this.addressShowDialogForm,
              enabled: true,
              receiveAddressCountry: this.currentSelectAddressCountry,
            });
          }
          this.dialogVisibleAddressInfo = false;
        }
      })
    },
    validateEmail(rule, value, callback) {
      var reg=/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/;
      if (value === '') {
        callback(new Error(`${$t('common.plzInput')}${$t('crm.receiveEmail')}`));
      } else if(!reg.test(value)) {
        callback(new Error(this.$t('common.validateEmail')));
      } else {
        callback();
      }
    },
  },
  computed: {
    saleAfterAddressData() {
      return this.ruleForm.afterAddressVos.filter((item) => item.enabled);
    }
  },
};
</script>

<style lang="less" scoped>
.buyerShop {
  position: relative;
  padding: 20px 20px 100px 20px;

  .footer-bar {
    position: fixed;
    right: 20px;
    bottom: 0;
    left: 210px;
    display: flex;
    align-items: center;
    height: 48px;
    padding: 0 20px;
    transition: left 0.3s;
    background-color: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    border-radius: 10px 10px 0 0;
    z-index: 10;
  }
}
.form-btn {
  margin-top: 40px;
}
.f12 {
  font-size: 12px;
}
.mt10 {
  margin-top: 10px;
}
.mt20 {
  margin-top: 20px;
}
.mt30 {
  margin-top: 30px;
}
.mb10 {
  margin-bottom: 10px;
}
.mb15 {
  margin-bottom: 15px;
}
.mb20 {
  margin-bottom: 20px;
}
.mb30 {
  margin-bottom: 30px;
}
.mb40 {
  margin-bottom: 40px;
}
.pl20 {
  padding-left: 20px;
}
.tr {
  text-align: right;
}
.radio-list {
  display: block;
  line-height: 25px;
}
</style>
